import React, { useState, useEffect } from "react";
import { array, func, bool } from "prop-types";
import ArrowDown from "../../../../assets/icons/arrowDown";
import CheckboxIcon from "../../../../assets/icons/CheckboxIcon";
import UncheckedIcon from "../../../../assets/icons/UncheckedIcon";
import { Icon } from "../../atoms/icon";
import { FilterPills } from "../filter-pills";
import "./region-filter.m.css";

export const RegionFilter = ({
  availableRegions = [],
  selectedRegions = [],
  onRegionSelect,
  onRegionRemove,
  onClearAll,
  onPageReset,
  isMobile = false,
  allowMultiSelect = false,
  ...props
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleRegionSelect = (region) => {
    if (isMobile) {
      const isSelected = selectedRegions.includes(region);
      if (isSelected) {
        if (onRegionRemove) {
          onRegionRemove(region);
        }
      } else {
        if (onRegionSelect) {
          onRegionSelect(region);
        }
      }
    } else {
      if (onRegionSelect) {
        onRegionSelect(region);
      }
      setIsOpen(false);
    }

    if (onPageReset) {
      onPageReset(1);
    }
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleReset = () => {
    if (onClearAll) {
      onClearAll();
    }
    if (isMobile) {
      setIsOpen(false);
    }

    if (onPageReset) {
      onPageReset(1);
    }
  };

  const handleClickOutside = (e) => {
    if (!e.target.closest('[data-region-filter]')) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    if (isOpen && !isMobile) {
      document.addEventListener('click', handleClickOutside);
      return () => document.removeEventListener('click', handleClickOutside);
    }
  }, [isOpen, isMobile]);

  useEffect(() => {
    if (isOpen && isMobile) {
      document.body.style.overflow = 'hidden';
      document.body.classList.add("modal-open");
    } else {
      document.body.style.overflow = 'unset';
      document.body.classList.remove("modal-open");
    }
    return () => {
      document.body.style.overflow = 'unset';
      document.body.classList.remove("modal-open");
    };
  }, [isOpen, isMobile]);

  return (
    <div styleName="region-filter" data-region-filter {...props}>
      <button
        styleName="filter-button"
        onClick={handleToggleDropdown}
        type="button"
      >
        <span styleName="filter-text">Filter by Cities</span>
        <div styleName="filter-icon" style={{ transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)' }}>
          <ArrowDown />
        </div>
      </button>

      {isOpen && (
        <div styleName={isMobile ? "mobile-filter-modal" : "dropdown-menu"}>
          {isMobile ? (
            <div styleName="mobile-filter-content">
              <div styleName="mobile-filter-header">
                <div styleName="mobile-filter-title">
                  <h3>Filter by region</h3>
                </div>
                <button
                  type="button"
                  styleName="close-button"
                  onClick={handleClose}
                  aria-label="Close filter"
                >
                  <Icon name="close" size="xsmall" />
                </button>
              </div>

              <div styleName="mobile-filter-body">
                {selectedRegions.length > 0 && (
                  <div styleName="mobile-filter-pills-section">
                    <FilterPills
                      selectedRegions={selectedRegions}
                      onRemoveFilter={(region) => {
                        onRegionRemove(region);
                        if (onPageReset) {
                          onPageReset(1);
                        }
                      }}
                      onClearAll={() => {
                        onClearAll();
                        if (onPageReset) {
                          onPageReset(1);
                        }
                      }}
                    />
                  </div>
                )}

                <div styleName="mobile-regions-list">
                  {availableRegions.length > 0 ? (
                    availableRegions.map((region) => {
                      const isSelected = selectedRegions.includes(region);
                      return (
                        <div
                          key={region}
                          styleName={`mobile-filter-item ${isSelected ? 'selected' : ''}`}
                          onClick={() => handleRegionSelect(region)}
                        >
                          {isSelected ? <CheckboxIcon /> : <UncheckedIcon />}
                          <span styleName="region-label">{region}</span>
                        </div>
                      );
                    })
                  ) : (
                    <div style={{ padding: '24px var(--spacing-l)', color: '#8f8f8f', textAlign: 'center' }}>
                      No regions available
                    </div>
                  )}
                </div>
              </div>

              <div styleName="mobile-filter-footer">
                <button
                  type="button"
                  styleName="reset-button"
                  onClick={handleReset}
                >
                  Reset
                </button>
                <button
                  type="button"
                  styleName="apply-button"
                  onClick={handleClose}
                >
                  Apply
                </button>
              </div>
            </div>
          ) : availableRegions.length > 0 ? (
            availableRegions.map((region) => {
              const isSelected = selectedRegions.includes(region);
              return (
                <button
                  key={region}
                  type="button"
                  styleName={`dropdown-item ${isSelected ? 'selected' : ''}`}
                  onClick={() => handleRegionSelect(region)}
                >
                  {isSelected ? <CheckboxIcon /> : <UncheckedIcon />}
                  {region}
                </button>
              );
            })
          ) : (
            <div style={{ padding: '8px 0', color: '#8f8f8f', fontSize: '14px', textAlign: 'center' }}>
              No regions available
            </div>
          )}
        </div>
      )}
    </div>
  );
};

RegionFilter.propTypes = {
  availableRegions: array,
  selectedRegions: array,
  onRegionSelect: func,
  onRegionRemove: func,
  onClearAll: func,
  onPageReset: func,
  isMobile: bool,
  allowMultiSelect: bool
};
